import { Injectable } from '@angular/core';
import { from, Observable, switchMap } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { global } from "./global";
import { AuthService } from "./auth.service";
import { memoryCopy } from "../utils/memory-file";

@Injectable({
    providedIn: 'root'
})
export class UploadService {

    url: string;
    urlCropper: string;

    constructor(
        private http: HttpClient,
        private auth: AuthService
    ) {
        this.url = global.getUrl();
        this.urlCropper = global.getUrlCropper();
    }

    uploadFileIncidencia(fileToUpload: File, idAlbara: number, tipoFoto: string): Observable<any> {
        const endpoint = this.url + 'xofers/upload?reference=' + idAlbara + '&tipoFoto=' + tipoFoto;

        return this.postFile(endpoint, 'Documents', fileToUpload, {Authorization: this.auth.getToken()});
    }

    scannFotoAlbaran(image: File): Observable<any> {
        const endpoint = this.urlCropper + '/scannImage';

        return this.postFile(endpoint, 'image', image); //, {Authorization: this.auth.getToken()}
    }

    uploadFotoAlbaran(path: string, idAlbara: number, tipoFoto: string, uploadId?: string): Observable<any> {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Authorization', this.auth.getToken());

        const endpoint = this.url + 'xofers/upload?reference=' + idAlbara + '&tipoFoto=' + tipoFoto + this.uploadIdParam(uploadId);

        return this.http.post(endpoint, 'base64=' + encodeURIComponent(path), {headers});
    }

    uploadFotoLlegadasSalidas(fileToUpload: File, idAlbara: number, tipoFoto: string, idCheck: number, uploadId?: string): Observable<any> {
        const endpoint = this.url + 'xofers/upload?reference=' + idAlbara + '&tipoFoto=' + tipoFoto + '&idCheck=' + idCheck + this.uploadIdParam(uploadId);

        return this.postFile(endpoint, 'Documents', fileToUpload, {Authorization: this.auth.getToken()});
    }

    uploadMandatoryPhotoSRCB(fileToUpload: File, idAlbara: number, tipoFoto: string, idCheck: string | undefined): Observable<any> {
        const endpoint = this.url + 'xofers/upload?reference=' + idAlbara + '&tipoFoto=' + tipoFoto + '&idCheck=' + idCheck;

        return this.postFile(endpoint, 'Documents', fileToUpload, {Authorization: this.auth.getToken()});
    }

    uploadFiles(base64: string, idAlbara: number, tipoFoto: string): Observable<any> {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Authorization', this.auth.getToken());

        const endpoint = this.url + 'xofers/upload?reference=' + idAlbara + '&tipoFoto=' + tipoFoto;

        return this.http.post(endpoint, 'base64=' + encodeURIComponent(base64), {headers});
    }

    uploadFilesDocs(file: File, idAlbara: number, tipoFoto: string): Observable<any> {
        const endpoint = this.url + 'xofers/upload?reference=' + idAlbara + '&tipoFoto=' + tipoFoto;

        return this.postFile(endpoint, 'Documents', file, {Authorization: this.auth.getToken()});
    }

    private uploadIdParam(uploadId?: string): string {
        return uploadId ? '&uploadId=' + encodeURIComponent(uploadId) : '';
    }

    // Sube siempre una copia en memoria del archivo, nunca el original (ver memoryCopy).
    private postFile(endpoint: string, field: string, file: File, headers?: {[header: string]: string}): Observable<any> {
        return from(memoryCopy(file)).pipe(
            switchMap(copy => {
                const formData: FormData = new FormData();
                formData.append(field, copy, copy.name);

                return this.http.post(endpoint, formData, {headers});
            })
        );
    }

    getFiles(id: number): Observable<any> {
        const headers = new HttpHeaders()
            .set('Content-Type', 'Application/x-www-form-urlencoded')
            .set('Authorization', this.auth.getToken());

        return this.http.get(global.getUrl() + 'xofers/getdocuments?idAlbara=' + id, {headers: headers});
    }

    getImages(id: number): Observable<any> {
        const headers = new HttpHeaders()
            .set('Content-Type', 'Application/x-www-form-urlencoded')
            .set('Authorization', this.auth.getToken());

        return this.http.get(global.getUrl() + 'xofers/getimages?idAlbaran=' + id, {headers: headers});
    }
}
